function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/suggested/close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "u0eqq8hrga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/close (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/close (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/close",
    style: {
      clipPath: "url(#u0eqq8hrga)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/close (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/close (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.644 7.641 14.8.307A.186.186 0 0 0 14.653 0h-1.87a.382.382 0 0 0-.288.134L7.42 6.183 2.346.134A.375.375 0 0 0 2.058 0H.188a.186.186 0 0 0-.143.307L6.2 7.641.045 14.974a.186.186 0 0 0 .143.307h1.87a.382.382 0 0 0 .288-.134L7.42 9.1l5.074 6.049a.375.375 0 0 0 .288.134h1.87a.186.186 0 0 0 .143-.307z",
    transform: "translate(4.57 4.359)",
    style: {
      fill: "#d9d9d9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c98bb5aa9bde1699fa912d3b6d9dba5b.svg";
export { ForwardRef as ReactComponent };